module.exports = __webpack_public_path__ + "img/img26.2dd396c4.png";